<template>
  <div class="contenedor">

    <h1 class="title-vista">
      {{ $i18n.locale === 'en' ? 'AKASHIC RECORDS COURSES' : 'CURSOS DE REGISTROS AKÁSHICOS' }}
    </h1>

    <!-- Introducción -->
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'Welcome to this space of expansion and reconnection with your soul.'
        : 'Bienvenido/a a este espacio de expansión y reconexión con tu alma.' }}
    </p>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'The Akashic Records are a sacred tool that allows access to the memory of the soul, facilitating deep processes of healing, understanding, and spiritual evolution.'
        : 'Los Registros Akáshicos son una herramienta sagrada que permite acceder a la memoria del alma, facilitando procesos profundos de sanación, comprensión y evolución espiritual.' }}
    </p>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'Each of these programs has been designed from experience, channeling, and love, integrating practical tools and close guidance, so you can live this connection in a conscious and transformative way.'
        : 'Cada uno de estos programas ha sido diseñado desde la experiencia, la canalización y el amor, integrando herramientas prácticas y acompañamiento cercano, para que puedas vivir esta conexión de forma consciente y transformadora.' }}
    </p>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'Whether you seek personal growth or feel the call to guide others, here you will find a safe, ethical, and deeply enriching space.'
        : 'Ya sea que busques crecimiento personal o sientas el llamado a acompañar a otros, aquí encontrarás un espacio seguro, ético y profundamente enriquecedor.' }}
    </p>
    <div class="author-section mt-5 mb-5">
      <div class="author-image-wrapper">
        <img src="/assets/imgs/beatriz2.jpg" alt="Beatriz Rojas" class="author-image" />
      </div>
      <p class="firma text-left m-0 border-0 p-0">
        <strong>Beatriz Rojas</strong><br>
        <span class="author-role">{{ $i18n.locale === 'en' ? 'Channeler and Akashic Records Teacher' : 'Canalizadora y Maestra de Registros Akáshicos' }}</span><br>
        <em>Misty Oracle S.L.</em>
      </p>
    </div>
    <!-- Metodología -->
    <h2 class="seccion-titulo">{{ $i18n.locale === 'en' ? 'METHODOLOGY' : 'METODOLOGÍA' }}</h2>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'Our approach goes beyond theory. This program has been designed as an experiential journey, where each student can integrate the Akashic Records from practice, awareness, and close guidance.'
        : 'Nuestro enfoque va más allá de la teoría. Este programa ha sido diseñado como una experiencia vivencial, donde cada alumno puede integrar los Registros Akáshicos desde la práctica, la conciencia y el acompañamiento cercano.' }}
    </p>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'Each session is designed so that you not only receive information, but experience connecting with the Akashic Records in real time.'
        : 'Cada sesión está pensada para que no solo recibas información, sino que vivas la experiencia de conectar con los Registros Akáshicos en tiempo real.' }}
    </p>
    <ul class="lista-cursos">
      <li>{{ $i18n.locale === 'en' ? 'Live classes with active participation' : 'Clases en vivo con participación activa' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Guided practices in each session' : 'Prácticas guiadas en cada sesión' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Integration and reflection spaces' : 'Espacios de integración y reflexión' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Real-time Q&A' : 'Resolución de dudas en tiempo real' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Close guidance throughout the process' : 'Acompañamiento cercano durante todo el proceso' }}</li>
    </ul>

    <!-- Modalidades -->
    <h2 class="seccion-titulo">{{ $i18n.locale === 'en' ? 'TRAINING MODALITIES' : 'MODALIDADES DE FORMACIÓN' }}</h2>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'This program is available in group and individual modalities, both designed to offer a deep and transformative experience.'
        : 'Este programa está disponible en modalidad grupal e individual, ambas diseñadas para ofrecer una experiencia profunda y transformadora.' }}
    </p>
    <div class="modalidad-card">
      <h3>{{ $i18n.locale === 'en' ? 'Group Modality' : 'Modalidad Grupal' }}</h3>
      <p>{{ $i18n.locale === 'en'
        ? 'The group format allows you to share the process with other souls on the path, creating an enriching space for learning, practice, and exchange. The group energy enhances the experience, providing different perspectives and facilitating broader integration.'
        : 'El formato grupal permite compartir el proceso con otras almas en camino, generando un espacio enriquecedor de aprendizaje, práctica e intercambio. La energía del grupo potencia la experiencia, aportando diferentes perspectivas y facilitando una integración más amplia.' }}</p>
    </div>
    <div class="modalidad-card">
      <h3>{{ $i18n.locale === 'en' ? 'Individual Modality' : 'Modalidad Individual' }}</h3>
      <p>{{ $i18n.locale === 'en'
        ? 'The individual modality offers a more intimate and personalized space, where the process adapts completely to your rhythm, needs, and evolutionary moment. It is ideal if you seek deeper guidance and an even more focused connection.'
        : 'La modalidad individual ofrece un espacio más íntimo y personalizado, donde el proceso se adapta completamente a tu ritmo, necesidades y momento evolutivo. Es ideal si buscas un acompañamiento más profundo y una conexión aún más enfocada.' }}</p>
    </div>

    <!-- Por qué elegir -->
    <h2 class="seccion-titulo">{{ $i18n.locale === 'en' ? 'WHY CHOOSE THIS COURSE?' : '¿POR QUÉ ELEGIR ESTE CURSO?' }}</h2>
    <p class="parrafo-justificado">
      {{ $i18n.locale === 'en'
        ? 'Because this is not just a course, it is a space of transformation. Unlike massive trainings where information is transmitted unidirectionally, here you will experience a guided, conscious, and deeply human process.'
        : 'Porque este no es solo un curso, es un espacio de transformación. A diferencia de formaciones masivas donde la información se transmite de forma unidireccional, aquí vivirás un proceso acompañado, consciente y profundamente humano.' }}
    </p>
    <ul class="lista-cursos">
      <li>{{ $i18n.locale === 'en' ? 'Close and personalized guidance' : 'Acompañamiento cercano y personalizado' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Real practice spaces during training' : 'Espacios reales de práctica durante la formación' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Conscious integration of each tool' : 'Integración consciente de cada herramienta' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Ethical, spiritual, and responsible approach' : 'Enfoque ético, espiritual y responsable' }}</li>
      <li>{{ $i18n.locale === 'en' ? 'Channeling and guidance from experience' : 'Canalización y guía desde la experiencia' }}</li>
    </ul>

    <!-- NIVEL 1 -->
    <div class="nivel-card">
      <h2 class="nivel-titulo">{{ $i18n.locale === 'en' ? 'LEVEL 1 — AKASHIC RECORDS PRACTITIONER' : 'NIVEL 1 — PRACTICANTE DE REGISTROS AKÁSHICOS' }}</h2>
      <p class="parrafo-justificado">
        {{ $i18n.locale === 'en'
          ? 'This initial level opens the doors to the Akashic field and provides practical tools for channeling information for yourself and others, from a loving, ethical, and conscious foundation.'
          : 'Este nivel inicial te abre las puertas al campo akáshico y te brinda herramientas prácticas para canalizar información para ti y para otros, desde una base amorosa, ética y consciente.' }}
      </p>
      <h4>{{ $i18n.locale === 'en' ? 'Content' : 'Contenido' }}</h4>
      <ul class="lista-cursos">
        <li v-for="(item, i) in nivel1Contenido" :key="'n1'+i">{{ $i18n.locale === 'en' ? item.en : item.es }}</li>
      </ul>
      <div class="nivel-info">
        <p><strong>{{ $i18n.locale === 'en' ? 'Duration' : 'Duración' }}:</strong> 14 {{ $i18n.locale === 'en' ? 'hours (7 days — 2 hours per class)' : 'horas (7 días — 2 horas por clase)' }}</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Modality' : 'Modalidad' }}:</strong> Online {{ $i18n.locale === 'en' ? 'live' : 'en vivo' }} (Google Meet)</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Language' : 'Idioma' }}:</strong> {{ $i18n.locale === 'en' ? 'Spanish' : 'Español' }}</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Certification' : 'Certificación' }}:</strong> {{ $i18n.locale === 'en' ? 'Akashic Records Practitioner — Issued by Misty Oracle S.L. and Beatriz Rojas' : 'Practicante de Registros Akáshicos — Emitido por Misty Oracle S.L. y Beatriz Rojas' }}</p>
      </div>
      <h4>{{ $i18n.locale === 'en' ? 'Includes' : 'Incluye' }}</h4>
      <ul class="lista-cursos">
        <li>{{ $i18n.locale === 'en' ? 'Support resources and complementary material' : 'Recursos de apoyo y material complementario' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Session recordings' : 'Grabaciones de las sesiones' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Support space (WhatsApp or Telegram)' : 'Espacio de acompañamiento (WhatsApp o Telegram)' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Personalized mentoring for 1 month' : 'Mentoría personalizada durante 1 mes' }}</li>
      </ul>
      <p class="precio-curso">
        <span>{{ $i18n.locale === 'en' ? 'Group' : 'Grupal' }}: $200 USD</span>
        <span>{{ $i18n.locale === 'en' ? 'Individual' : 'Individual' }}: $450 USD</span>
      </p>
      <div class="cta-container">
        <b-button variant="primary" size="lg" @click="contactar">
          {{ $i18n.locale === 'en' ? 'Start my training' : 'Comenzar mi formación' }}
        </b-button>
      </div>
    </div>

    <!-- NIVEL 2 -->
    <div class="nivel-card">
      <h2 class="nivel-titulo">{{ $i18n.locale === 'en' ? 'LEVEL 2 — AKASHIC HEALER' : 'NIVEL 2 — SANADOR AKÁSHICO' }}</h2>
      <p class="parrafo-justificado">
        {{ $i18n.locale === 'en'
          ? 'Deepen the therapeutic use of the Akashic Records, accessing healing tools to work on physical, emotional, mental, and spiritual levels.'
          : 'Profundiza en el uso terapéutico de los Registros Akáshicos, accediendo a herramientas de sanación para trabajar a nivel físico, emocional, mental y espiritual.' }}
      </p>
      <h4>{{ $i18n.locale === 'en' ? 'Content' : 'Contenido' }}</h4>
      <ul class="lista-cursos">
        <li v-for="(item, i) in nivel2Contenido" :key="'n2'+i">{{ $i18n.locale === 'en' ? item.en : item.es }}</li>
      </ul>
      <div class="nivel-info">
        <p><strong>{{ $i18n.locale === 'en' ? 'Duration' : 'Duración' }}:</strong> 14 {{ $i18n.locale === 'en' ? 'hours (7 days — 2 hours per class)' : 'horas (7 días — 2 horas por clase)' }}</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Modality' : 'Modalidad' }}:</strong> Online {{ $i18n.locale === 'en' ? 'live' : 'en vivo' }} (Google Meet)</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Language' : 'Idioma' }}:</strong> {{ $i18n.locale === 'en' ? 'Spanish' : 'Español' }}</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Certification' : 'Certificación' }}:</strong> {{ $i18n.locale === 'en' ? 'Akashic Healer — Advanced Practitioner — Issued by Misty Oracle S.L. and Beatriz Rojas' : 'Sanador Akáshico — Practicante Avanzado — Emitido por Misty Oracle S.L. y Beatriz Rojas' }}</p>
      </div>
      <h4>{{ $i18n.locale === 'en' ? 'Includes' : 'Incluye' }}</h4>
      <ul class="lista-cursos">
        <li>{{ $i18n.locale === 'en' ? 'Support resources and complementary material' : 'Recursos de apoyo y material complementario' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Session recordings' : 'Grabaciones de las sesiones' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Support space (WhatsApp or Telegram)' : 'Espacio de acompañamiento (WhatsApp o Telegram)' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Personalized mentoring for 1 month' : 'Mentoría personalizada durante 1 mes' }}</li>
      </ul>
      <p class="precio-curso">
        <span>{{ $i18n.locale === 'en' ? 'Group' : 'Grupal' }}: $300 USD</span>
        <span>{{ $i18n.locale === 'en' ? 'Individual' : 'Individual' }}: $550 USD</span>
      </p>
      <div class="cta-container">
        <b-button variant="primary" size="lg" @click="contactar">
          {{ $i18n.locale === 'en' ? 'Start my training' : 'Comenzar mi formación' }}
        </b-button>
      </div>
    </div>

    <!-- NIVEL 3 -->
    <div class="nivel-card">
      <h2 class="nivel-titulo">{{ $i18n.locale === 'en' ? 'LEVEL 3 — TEACHER AND TRAINER' : 'NIVEL 3 — MAESTRO Y FORMADOR' }}</h2>
      <p class="parrafo-justificado">
        {{ $i18n.locale === 'en'
          ? 'Aimed at those who feel the call to teach and guide others. This level prepares you to train practitioners and support processes from a solid energetic, ethical, and spiritual foundation.'
          : 'Dirigido a quienes sienten el llamado a enseñar y guiar a otros. Este nivel te prepara para formar practicantes y sostener procesos desde una base energética, ética y espiritual sólida.' }}
      </p>
      <h4>{{ $i18n.locale === 'en' ? 'Content' : 'Contenido' }}</h4>
      <ul class="lista-cursos">
        <li v-for="(item, i) in nivel3Contenido" :key="'n3'+i">{{ $i18n.locale === 'en' ? item.en : item.es }}</li>
      </ul>
      <div class="nivel-info">
        <p><strong>{{ $i18n.locale === 'en' ? 'Duration' : 'Duración' }}:</strong> 10 {{ $i18n.locale === 'en' ? 'hours (5 days — 2 hours per class)' : 'horas (5 días — 2 horas por clase)' }}</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Modality' : 'Modalidad' }}:</strong> Online {{ $i18n.locale === 'en' ? 'live' : 'en vivo' }} (Google Meet)</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Language' : 'Idioma' }}:</strong> {{ $i18n.locale === 'en' ? 'Spanish' : 'Español' }}</p>
        <p><strong>{{ $i18n.locale === 'en' ? 'Certification' : 'Certificación' }}:</strong> {{ $i18n.locale === 'en' ? 'Akashic Records Teacher and Trainer — Issued by Misty Oracle S.L. and Beatriz Rojas' : 'Maestro/a y Formador/a en Registros Akáshicos — Emitido por Misty Oracle S.L. y Beatriz Rojas' }}</p>
      </div>
      <h4>{{ $i18n.locale === 'en' ? 'Includes' : 'Incluye' }}</h4>
      <ul class="lista-cursos">
        <li>{{ $i18n.locale === 'en' ? 'Support resources and complementary material' : 'Recursos de apoyo y material complementario' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Session recordings' : 'Grabaciones de las sesiones' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Support space (WhatsApp or Telegram)' : 'Espacio de acompañamiento (WhatsApp o Telegram)' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Personalized mentoring for 1 month' : 'Mentoría personalizada durante 1 mes' }}</li>
      </ul>
      <p class="precio-curso">
        <span>{{ $i18n.locale === 'en' ? 'Group' : 'Grupal' }}: $350 USD</span>
        <span>{{ $i18n.locale === 'en' ? 'Individual' : 'Individual' }}: $700 USD</span>
      </p>
      <div class="cta-container">
        <b-button variant="primary" size="lg" @click="contactar">
          {{ $i18n.locale === 'en' ? 'Start my training' : 'Comenzar mi formación' }}
        </b-button>
      </div>
    </div>

    <!-- Planes de pago -->
    <div class="planes-pago">
      <h2 class="seccion-titulo">{{ $i18n.locale === 'en' ? 'PAYMENT PLANS' : 'PLANES DE PAGO' }}</h2>
      <ul class="lista-cursos">
        <li>{{ $i18n.locale === 'en' ? 'Reserve your spot with an initial payment' : 'Reserva de cupo con pago inicial' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Possibility of splitting the payment' : 'Posibilidad de fraccionar el pago' }}</li>
        <li>{{ $i18n.locale === 'en' ? 'Special conditions for students and recurring clients' : 'Condiciones especiales para alumnos y clientes recurrentes' }}</li>
      </ul>
      <p class="parrafo-justificado">
        {{ $i18n.locale === 'en'
          ? 'For more information, contact us at:'
          : 'Para más información, puedes contactarnos al correo:' }}
        <a href="mailto:beatrizrojas@mistyoracle.com" class="email-link">beatrizrojas@mistyoracle.com</a>
      </p>
    </div>

    <!-- Cierre -->
    <div class="cierre-cursos">
      <p class="parrafo-justificado">
        {{ $i18n.locale === 'en'
          ? 'This program integrates proprietary tools, Akashic channeling, and carefully selected complementary material, offering close, human, and personalized guidance at every stage of the process.'
          : 'Este programa integra herramientas propias, canalización akáshica y material complementario cuidadosamente seleccionado, ofreciendo un acompañamiento cercano, humano y personalizado en cada etapa del proceso.' }}
      </p>
      <p class="parrafo-justificado" style="font-style: italic;">
        {{ $i18n.locale === 'en'
          ? 'If this path has reached you, it is no coincidence. Your soul already recognizes the wisdom that is ready to awaken.'
          : 'Si este camino ha llegado a ti, no es casualidad. Tu alma ya reconoce la sabiduría que está lista para despertar.' }}
      </p>
      <p class="parrafo-justificado">
        {{ $i18n.locale === 'en'
          ? 'It will be an honor to accompany you in this process of connection, healing, and expansion.'
          : 'Será un honor acompañarte en este proceso de conexión, sanación y expansión.' }}
      </p>
      <div class="cta-container mt-5">
        <b-button variant="primary" size="lg" @click="contactar">
          {{ $i18n.locale === 'en' ? 'Start my training' : 'Comenzar mi formación' }}
        </b-button>
      </div>
      <div class="text-center mt-4">
        <p class="font-italic" style="color: var(--color-font-misty-oracle);">
          <small>{{ $i18n.locale === 'en' ? '* This training is currently only available in Spanish.' : '* Esta formación se imparte actualmente solo en idioma español.' }}</small>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "CursosDetail",
  data() {
    return {
      nivel1Contenido: [
        { es: '¿Qué son los Registros Akáshicos?', en: 'What are the Akashic Records?' },
        { es: 'Uso de la oración sagrada', en: 'Use of the sacred prayer' },
        { es: 'Lectura de registros propios y de otros', en: 'Reading your own and others\' records' },
        { es: 'Solicitud de guía desde Akasha', en: 'Requesting guidance from Akasha' },
        { es: 'Carta del alma (las características de tu alma: color de tu alma, animal de poder o espiritual, guia espiritual…).', en: 'Soul letter (characteristics of your soul: soul color, power or spiritual animal, spiritual guide…).' },
        { es: 'Lectura de vidas pasadas', en: 'Past lives reading' },
        { es: 'Escaneo y balanceo de chakras', en: 'Chakra scanning and balancing' },
        { es: 'Carga, estabilización, sanación y protección del aura.', en: 'Charging, stabilization, healing, and protection of the aura.' },
        { es: 'Limpieza energética de bienes y espacios físicos', en: 'Energetic cleaning of assets and physical spaces' },
        { es: 'Comunicación con guías y ancestros', en: 'Communication with guides and ancestors' },
        { es: 'Manifestación consciente', en: 'Conscious manifestation' },
      ],
      nivel2Contenido: [
        { es: 'Sanación del niño interior', en: 'Inner child healing' },
        { es: 'Sanación de ancestros', en: 'Ancestral healing' },
        { es: 'Sanación del alma', en: 'Soul healing' },
        { es: 'Sanación de relaciones kármicas', en: 'Karmic relationship healing' },
        { es: 'Sanación de vidas pasadas', en: 'Past lives healing' },
        { es: 'Sanación financiera', en: 'Financial healing' },
        { es: 'Sanación de salud física', en: 'Physical health healing' },
        { es: 'Sanación emocional', en: 'Emotional healing' },
        { es: 'Sanación de relaciones', en: 'Relationship healing' },
        { es: 'Sanación de camino profesional y laboral', en: 'Professional and career path healing' },
        { es: 'Sanación en educación', en: 'Education healing' },
        { es: 'Sanación de fertilidad y salud del útero', en: 'Fertility and womb health healing' },
        { es: 'Sanación de Mascotas', en: 'Pet healing' },
      ],
      nivel3Contenido: [
        { es: 'Sintonización akáshica', en: 'Akashic attunement' },
        { es: 'Formación de nuevos practicantes', en: 'Training new practitioners' },
        { es: 'Los 7 cuerpos energéticos', en: 'The 7 energetic bodies' },
        { es: 'Ley del karma', en: 'Law of karma' },
        { es: 'Técnicas de meditación guiada', en: 'Guided meditation techniques' },
        { es: 'Activación de la glándula pineal', en: 'Pineal gland activation' },
        { es: 'Puntos de gracia', en: 'Grace points' },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    contactar() {
      this.$router.push({ name: 'Contactanos' }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  padding: 50px 300px;
  width: 100%;
}

p {
  font-size: 1.4rem;
  margin-top: 30px;
  text-align: left;
}

.firma {
  font-size: 1.1rem;
  margin-top: 40px;
  margin-bottom: 60px;
}

.author-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  background-color: #f9f5fb;
  padding: 25px 40px;
  border-radius: 12px;
  max-width: 600px;
  margin: 0 auto;
  border: 1px solid rgba(235, 16, 144, 0.2);
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

.author-image {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--primary-misty-oracle);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.author-role {
  color: var(--primary-misty-oracle);
  font-weight: 500;
}

.seccion-titulo {
  font-size: 1.7rem;
  font-weight: bold;
  color: var(--primary-misty-oracle);
  text-align: center;
  margin-top: 60px;
  margin-bottom: 20px;
  letter-spacing: 2px;
}

.lista-cursos {
  font-size: 1.3rem;
  margin-top: 15px;
  text-align: left;
  padding-left: 25px;
  list-style-position: outside;
  li {
    margin-bottom: 6px;
    text-align: left;
  }
}

.modalidad-card {
  background-color: #f9f5fb;
  border-left: 4px solid var(--primary-misty-oracle);
  padding: 25px 30px;
  margin: 20px 0;
  border-radius: 6px;
  h3 {
    font-size: 1.4rem;
    color: var(--primary-misty-oracle);
    margin-bottom: 10px;
  }
  p {
    font-size: 1.2rem;
    margin-top: 0;
  }
}

.nivel-card {
  border: 2px solid var(--primary-misty-oracle);
  border-radius: 10px;
  padding: 40px;
  margin: 50px 0;
  h4 {
    font-size: 1.3rem;
    font-weight: bold;
    color: var(--primary-misty-oracle);
    margin-top: 25px;
    margin-bottom: 10px;
  }
}

.nivel-titulo {
  font-size: 1.6rem;
  font-weight: bold;
  color: var(--primary-misty-oracle);
  text-align: center;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.nivel-info {
  margin-top: 20px;
  p {
    font-size: 1.2rem;
    margin-top: 5px;
  }
}

.precio-curso {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.4rem;
  font-weight: bold;
  margin-top: 20px;
  span {
    margin: 3px 0;
  }
}

.cta-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.planes-pago {
  margin-top: 60px;
  padding: 30px;
  background-color: #f9f5fb;
  border-radius: 10px;
}

.email-link {
  color: var(--primary-misty-oracle);
  font-weight: bold;
}

.cierre-cursos {
  margin-top: 50px;
  text-align: center;
}

.parrafo-justificado {
  text-align: justify;
}

@media screen and (max-width: 1100px) {
  .contenedor {
    padding: 50px 15px;
  }

  p {
    font-size: 1.2rem;
    margin-top: 20px;
  }

  .lista-cursos {
    font-size: 1.1rem;
  }

  .nivel-card {
    padding: 20px;
    margin: 30px 0;
  }

  .seccion-titulo {
    font-size: 1.4rem;
  }

  .nivel-titulo {
    font-size: 1.3rem;
  }
}

  .precio-curso {
    font-size: 1.2rem;
  }

  .modalidad-card {
    padding: 15px;
  }

  .author-section {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }
</style>
